import styled from 'styled-components';
import { Heading, Text } from '@acin/ui-core';

export const PlaceholderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: ${(p) => p.theme.spacing.getSize(4)};
`;

export const PlaceholderText = styled.div`
  color: ${(p) => p.theme.colors.text.getValue(2)};
  font-size: ${(p) => p.theme.type.getSize()};
  text-align: center;
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
`;

export const DetailsHeader = styled.div`
  margin-bottom: ${(p) => p.theme.spacing.getSize(4)};
  padding-bottom: ${(p) => p.theme.spacing.getSize(4)};
  border-bottom: 1px solid ${(p) => p.theme.colors.borders.getValue(3)};
`;

export const DetailsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing.getSize(3)};
`;

export const DetailRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing.getSize(1)};
`;

export const SectionHeading = styled(Heading)`
  font-size: 12px;
  font-weight: 600;
  color: ${(p) => p.theme.colors.primary.getValue(700).main};
  text-transform: uppercase;
  margin-bottom: ${(p) => p.theme.spacing.getSize(2)};
`;

export const DescriptionParagraph = styled.p`
  font-size: ${(p) => p.theme.type.getSize()};
  color: ${(p) => p.theme.colors.text.getValue(1)};
  line-height: 1.5;
  margin: 0 0 ${(p) => p.theme.spacing.getSize(2)} 0;
  padding: 0;
`;
